<template>
  <v-container v-if="!createOrg" class="organization" fluid>
    <app-snackbar
      :text = "snackBarText"
      :show.sync = "snackbar"
      :color = "snackbarColor"
      :timeOut = "timeOut"
    ></app-snackbar>
    <v-flex xs12 sm6 offset-sm3 class="flex">
      <p class="font title">Introduce el código de la organización</p>
      <v-text-field class="font input-text" prepend-inner-icon="domain" name="name" append-outer-icon="send" @click:append-outer="joinOrganization" label="Código de la organización"
        v-model="organizationCode"
        type="name"
      ></v-text-field>
      <div class="div-create-org">
        <img class="icon" :src="require('../../assets/icons/add-organization.png')"/>
        <a class="font create-org-button" @click="newOrganizationButton">Crear organización</a>
      </div>
    </v-flex>
  </v-container>
  <v-container v-else class="organization" fluid>
  <app-snackbar
    :text = "snackBarText"
    :show.sync = "snackbar"
    :color = "snackbarColor"
    :timeOut = "timeOut"
  ></app-snackbar>
  <v-flex xs12 sm6 offset-sm3 class="flex">
    <p class="font title"><b>Nombra a la organización</b></p>
    <v-text-field class="font input-text" prepend-inner-icon="domain" name="name" label="Nombre de la organización"
      v-model="organizationName"
      type="name"
    ></v-text-field>
    <div class="div-continue-btn">
      <v-btn block :class="this.organizationName.length ? 'continue-btn' : 'continue-btn grey--text'" :color="this.organizationName.length ? 'info' : '#DFDFDF'" @click="createOrganizationButton">Crear organización</v-btn>
    </div>
  </v-flex>
</v-container>
</template>

<script>
  import { CREATE_ORGANIZATION_MUTATION, HASH_ORGANIZATION_QUERY, USER_QUERY, UPDATE_USER_ORGANIZATION_MUTATION, UPDATE_ORGANIZATION__ADMIN_MUTATION } from '../../constants/graphql';
  import { EventBus } from '../../lib/event-bus.js';

  export default {
    data () {
      return {
        User: {
          Organization: {
            User: [],
            Admin: [],
            Device: []
          }
        },
        organizationCode: '',
        organizationName: '',
        createOrg: false,
        snackbar: false,
        snackBarText: '',
        snackbarColor: '',
        timeOut: 5000
      };
    },
    apollo: {
      User: {
        query: USER_QUERY,
        variables () {
          return {
            id: this.$store.getters.user.id
          };
        }
      }
    },
    created () {
      this.$store.commit('setShowStepOrganization', false);
      EventBus.$on('go-back', () => {
        this.$store.commit('setShowStepOrganization', false);
      });
    },
    methods: {
      newOrganizationButton () {
        this.$store.commit('setShowStepOrganization', true);
        this.createOrg = true;
      },
      joinOrganization () {
        if (!this.$store.getters.isOnline) {
          this.snackbar = true;
          this.snackBarText = 'Sin conexión! Intenta nuevamente más tarde';
          this.snackbarColor = 'red';
          return;
        }
        if (!this.organizationCode.length) {
          this.snackbar = true;
          this.snackBarText = 'Debe ingresar un código primero';
          this.snackbarColor = 'red';
          return;
        }
        this.$apollo.mutate({
          mutation: HASH_ORGANIZATION_QUERY,
          variables: {
            hash: this.organizationCode.toUpperCase()
          }
        }).then((result) => {
          if (result.data && result.data.allOrganizations && result.data.allOrganizations[0]) {
            let organizationId = result.data.allOrganizations[0].id;
            this.$apollo.mutate({
              mutation: UPDATE_USER_ORGANIZATION_MUTATION,
              variables: {
                userId: this.$store.getters.user.id,
                orgId: organizationId
              }
            }).then((result) => {
              this.$apollo.queries.User.refresh();
              this.$router.push({ name: 'UserInfo' });
            });
          } else {
            this.snackbar = true;
            this.snackBarText = 'El código no corresponde a ninguna organización';
            this.snackbarColor = 'red';
          }
        }).catch(() => {
        });
      },
      createOrganizationButton () {
        if (!this.$store.getters.isOnline) {
          this.snackbar = true;
          this.snackBarText = 'Sin conexión! Intenta nuevamente más tarde';
          this.snackbarColor = 'red';
        } else {
          if (!this.organizationName.length) {
            this.snackbar = true;
            this.snackBarText = 'Debes definir un nombre primero';
            this.snackbarColor = 'red';
          } else {
            const hash = this.makeHash(4);
            this.$apollo.mutate({
              mutation: CREATE_ORGANIZATION_MUTATION,
              variables: {
                name: this.organizationName,
                hash: hash
              }
            }).then((result) => {
              const organizationId = result.data.createOrganization.id;
              this.User.Organization = {
                id: organizationId,
                name: result.data.createOrganization.name
              };
              this.$apollo.mutate({
                mutation: UPDATE_USER_ORGANIZATION_MUTATION,
                variables: {
                  userId: this.$store.getters.user.id,
                  orgId: organizationId
                }
              }).then((result) => {
                this.User.Organization.User = result.data.updateOrganization.User;
                this.$apollo.mutate({
                  mutation: UPDATE_ORGANIZATION__ADMIN_MUTATION,
                  variables: {
                    orgId: organizationId,
                    userId: this.$store.getters.user.id
                  }
                }).then((result) => {
                  this.User.Organization.Admin = result.data.updateOrganization.Admin;
                  this.$apollo.queries.User.refresh();
                  this.$router.push({ name: 'UserInfo', params: { organizationCreated: true } });
                }).catch(() => {
                });
              }).catch(() => {
              });
            }).catch(() => {
            });
          }
        }
      },
      makeHash (length) {
        let result = '';
        const characters = 'ABCDEFGJKLMNOPQRSTUVWXYZ0123456789';
        const charactersLength = characters.length;
        for (let i = 0; i < length; i++) {
          result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
      }
    }
  };
</script>


// WEBPACK FOOTER //
// NewOrganization.vue?2a44a066